import { render, staticRenderFns } from "./ExportarArrematantes.vue?vue&type=template&id=0d95278e&"
import script from "./ExportarArrematantes.vue?vue&type=script&lang=js&"
export * from "./ExportarArrematantes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports